import { useCallback, useEffect } from 'react';

import { EnumOpenDialog } from '../stores/ui/types';
import { useStores } from '../stores/useStores';

export function useForceChoosingCountry() {
  const {
    uiStore,
    userStore: { profile },
  } = useStores();
  const runCountryCheck = useCallback(() => {
    if (profile && !profile.isCountrySetByUser) {
      uiStore.setOpenDialog({ dialog: EnumOpenDialog.isOpenChooseCountryDialog });
    }
  }, [uiStore, profile]);

  useEffect(() => {
    if (uiStore.openDialog?.dialog === null) {
      runCountryCheck();
    }
  }, [runCountryCheck, uiStore.openDialog]);
}
